/** @format */
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * A hook used to setup infinite scrolling
 */
export const useInfiniteScroll = (callback: () => void) => {
    const [ref, inView] = useInView({
        rootMargin: '100px',
    });

    useEffect(() => {
        if (inView) {
            callback();
        }
    }, [inView]);

    return ref;
};
